


































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

type SettingsTab = {
  name: string;
  label: string;
  icon: string;
  iconV2: boolean;
};

@Component
export default class Settings extends Vue {
  @Getter("locked") readonly locked!: boolean;

  readonly tabs: SettingsTab[] = [
    {
      name: "SettingsAutomaticReports",
      label: "Report automatici",
      icon: "clock-fast-forward",
      iconV2: true,
    },
    {
      name: "SettingsTemplateReport",
      label: "Template report",
      icon: "table",
      iconV2: true,
    },
    // Hiding them at the moment. Those will be new features.
    // {
    //   name: "SettingsTimeSlots",
    //   label: "Fasce orarie",
    //   icon: "clock",
    //   iconV2: true,
    // },
    // {
    //   name: "SettingsSegments",
    //   label: "Segmenti",
    //   icon: "dataflow-04",
    //   iconV2: true,
    // },
    // {
    //   name: "SettingsPrices",
    //   label: "Prezzi",
    //   icon: "bank-note-01",
    //   iconV2: true,
    // },
  ];

  // Keep the selected profile in the URL when switching tabs.
  get menuQuery(): Record<string, string> {
    const profile = this.$route.query.profile;
    return typeof profile === "string" ? { profile } : {};
  }
}
